import { useAppDispatch, useAppSelector } from "redux/store";
import { SuccessModal } from "./success-modal";
import { ErrorModal } from "./error-modal";
import {
  dismissErrorModal,
  dismissSuccessModal,
  dismissSummaryModal,
} from "redux/slices";
import { selectModalsConfig } from "redux/selectors";
import { SummaryModal } from "./summary-modal";

export const ModalProvider = () => {
  const dispatch = useAppDispatch();
  const { errorConfig, successConfig, summaryConfig } =
    useAppSelector(selectModalsConfig);

  const handleCloseSuccessModal = () => {
    dispatch(dismissSuccessModal());
  };
  const handleCloseErrorModal = () => {
    dispatch(dismissErrorModal());
  };
  const handleCloseSummaryModal = () => {
    dispatch(dismissSummaryModal());
  };

  if (successConfig) {
    return (
      <SuccessModal
        show={true}
        {...successConfig}
        handleCloseModal={handleCloseSuccessModal}
      />
    );
  }
  if (errorConfig) {
    return (
      <ErrorModal
        show={true}
        {...errorConfig}
        handleCloseModal={handleCloseErrorModal}
      />
    );
  }
  if (summaryConfig) {
    return (
      <SummaryModal
        show={true}
        {...summaryConfig}
        handleCloseModal={handleCloseSummaryModal}
      />
    );
  }
  return null;
};
